<template>
  <!-- 产品服务-秒个贷 -->
  <div class="box mgd">
    <div v-if="!isM" class="mgd0 bgimg"></div>
    <div v-if="isM" class="mgdm0"></div>

    <div class="mgd1">
      <div class="min_box">
        <ul class="c1_box">
          <li v-for="(item, index) in arr" :key="item.id">
            <img
              :src="picUrl + 'mgd' + (index + 1) + '.png'"
              :alt="item.name"
            />
            <div>
              <p>{{ item.tit }}</p>
              <span>{{ item.dec }}</span>
            </div>
          </li>
        </ul>
        <img class="mgdphobe" :src="picUrl + 'mgdphone.png'" alt="秒个贷" />
      </div>
    </div>

    <div class="mgd2">
      <div class="min_box">
        <h4 class="blue_h4">金融优势</h4>
        <p class="gary_dec">低门槛 高返利</p>
        <ul class="mgd1_ul">
          <li v-for="(item, index) in arr1" :key="item.id">
            <img
              :src="picUrl + 'mgdj' + (index + 1) + '.png'"
              :alt="item.tit"
            />
            <p>{{ item.tit }}</p>
            <span>{{ item.dec }}</span>
          </li>
        </ul>
      </div>
    </div>

    <div class="mgd3">
      <div class="min_box">
        <h4 class="blue_h4">多金融机构合作</h4>
        <p class="gary_dec">量身定制车主分期</p>
        <img :src="picUrl + 'mgdpic.png'" alt="秒个贷图片" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Mgd",
  data() {
    return {
      picUrl: this.$root.picUrl,
      arr: [
        {
          tit: "超低息",
          dec: "月息低至0.31%",
        },
        {
          tit: "高收益",
          dec: "服务收益高达5%",
        },
        {
          tit: "高额度",
          dec: "可贷车价95%",
        },
        {
          tit: "长期限",
          dec: "还款可分5年60期",
        },
        {
          tit: "放款快",
          dec: "在线审批，当天放款",
        },
        {
          tit: "人群广",
          dec: "省内牌即可",
        },
      ],
      arr1: [
        {
          tit: "多金融渠道",
          dec: "超高通过率",
        },
        {
          tit: "平台化对接",
          dec: "极速放款",
        },
        {
          tit: "没有中间商",
          dec: "高佣金返利",
        },
      ],
    };
  },
  created() {
    this.isM = JSON.parse(sessionStorage.getItem("isM"));
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Proservices/mgd.vue